import React from 'react'
import FormLabel from '../Typography/FormLabel'
import { FormGroup, TextInput } from './styles'

const FormInput = ({
  children,
  textLabelColor,
  bold,
  label,
  margin,
  bg,
  textcolor,
  mb,
  border,
  borderbottom,
  fontWeight,
  fontfamily,
  padding,
  size,
  borderradius,
  ...props
}) => {
  return (
    <FormGroup mb={mb}>
      {label != null && (
        <FormLabel textLabelColor={textLabelColor} bold={bold} margin={margin}>
          {label}
        </FormLabel>
      )}
      <TextInput
        // onKeyPress={}
        bg={bg}
        borderradius={borderradius}
        textcolor={textcolor}
        border={border}
        borderbottom={borderbottom}
        fontfamily={fontfamily}
        fontWeight={fontWeight}
        padding={padding}
        size={size}
        {...props}
      >
        {children}
      </TextInput>
    </FormGroup>
  )
}

export default FormInput
